import { tns } from 'tiny-slider/src/tiny-slider';

class MediaContentSlider {
	constructor(el, prevButton, nextButton, nav) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;
		this.nav = nav;

		const mediaContentSlider = tns({
			container: this.el,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			nav: true,
			navPosition: "bottom",
			navContainer: this.nav
		});

		return mediaContentSlider;
		
	}
}

export default MediaContentSlider;